import axios from "axios"
import { logoutAction } from "../actions/auth"
import store from "../index"
import {
  loginOfflineUser,
  registerUser,
  updateCacheItem,
} from "../../view/shared/utilities/cache"
import Cookies from "js-cookie"

const airtableAPI = axios.create({
  baseURL: window.REACT_APP_PWA_AIRTABLE_URL,
  headers: {
    Authorization: `Bearer ${window.REACT_APP_PWA_AIRTABLE_API_KEY}`,
  },
})

const backendAPI = axios.create({
  baseURL: window.REACT_APP_PWA_APP_DOMAIN || "https://backend.staging.vsla.online",
})

const AuthAPI = axios.create({
  baseURL: window.REACT_APP_PWA_AUTH,
})

const transactionAPI = axios.create({
  baseURL:
    window.REACT_APP_PWA_TRANSACTIONS ||
    "https://transaction-service.staging.hivenetwork.online/transactions/vsla",
})

const blockchainAPI = axios.create({
  baseURL: window.REACT_APP_BLOCKCHAIN_API || "https://stellar.staging.vsla.online",
})

const locationAPI = axios.create({
  baseURL:
    window.REACT_APP_LOCATION_SERVICE ||
    "https://location-service.staging.hivenetwork.online",
  headers: {
    accessKey: window.REACT_APP_PWA_LOCATION_ACCESS_KEY,
  },
})

const APIS = [
  backendAPI,
  locationAPI,
  transactionAPI,
  blockchainAPI,
  AuthAPI,
  airtableAPI,
]

APIS.forEach((api) => {
  const NoneGetRequests = ["/login?app=vsla"]
  api.interceptors.request.use(
    (request) => {
      const config = request
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )
  api.interceptors.response.use(
    async (response) => {
      const { config } = response
      const isLoginResponse = NoneGetRequests.includes(config.url)
      if (config.method === "get" || isLoginResponse) {
        // a config for flexible caching
        let data = response.data
        if (isLoginResponse) {
          const username = JSON.parse(config.data).username
          const pin = JSON.parse(config.data).password
          // register user if not registered
          await registerUser(username, pin)
          await loginOfflineUser({
            url: username,
            data: data,
            timestamp: Date.now(),
          })
        } else {
          // cache data
          await updateCacheItem(
            "cacheStore",
            {
              url: config.url,
              data: data,
              timestamp: Date.now(),
            },
            "url",
            config.url,
          )
        }
      }
      return response
    },
    (error) => {
      const status = (error && error.response && error.response.status) || 500
      if ([403, 401].includes(status)) {
        store.dispatch(logoutAction())
      }
      return Promise.reject(error)
    },
  )
})

const setAuthorizationToken = (token, tokenBC) => {
  if (token && tokenBC) {
    localStorage.setItem("token", token)
    localStorage.setItem("tokenBC", tokenBC)
    backendAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`
    locationAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`
    blockchainAPI.defaults.headers.common["Authorization"] = `Bearer ${tokenBC}`
  } else {
    delete backendAPI.defaults.headers.common["Authorization"]
    delete blockchainAPI.defaults.headers.common["Authorization"]
    delete locationAPI.defaults.headers.common["Authorization"]
    localStorage.removeItem("token")
    localStorage.removeItem("tokenBC")
    Cookies.remove("token", { path: "/" }) // removed cookie
    Cookies.remove("tokenBC", { path: "/" }) // removed cookie
  }
}

export {
  backendAPI,
  transactionAPI,
  blockchainAPI,
  setAuthorizationToken,
  AuthAPI,
  airtableAPI,
  locationAPI,
}
